/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  loadAppData();


  // code to add multiple swipers on one page 
  const swiperSlides = document.querySelectorAll('.swiper:not(.product_imgs');
  let loopSetting = false;
  let scrollSetting = false;
  let slidesPerView = 'auto'
  swiperSlides.forEach((slide,i) => {
    slide.classList.add('swiper-'+i);
    if(slide.querySelector('.swiper-button-next') != null) slide.querySelector('.swiper-button-next').classList.add('swiper-button-next-'+i);
    if(slide.querySelector('.swiper-button-prev') != null) slide.querySelector('.swiper-button-prev').classList.add('swiper-button-prev-'+i);
    if(slide.querySelector('.swiper-pagination') != null) slide.querySelector('.swiper-pagination').classList.add('swiper-button-pagination-'+i);
    if(slide.querySelector('.swiper-scrollbar') != null)  slide.querySelector('.swiper-scrollbar').classList.add('swiper-scrollbar-'+i);

    if(slide.dataset.loop != undefined){
      loopSetting = true
    }
    if(slide.dataset.slidesPerView != undefined){
      slidesPerView = slide.dataset.slidesPerView
    }
    if(slide.dataset.scrollbar != undefined){
      scrollSetting = {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: 50
      }
    }
    // console.log('slidesPerView',slide.dataset.mobSpacebetween);


    

    var swiper = new Swiper('.swiper-'+i, {
      slidesPerView: 'auto',
      spaceBetween: slide.dataset.mobSpacebetween != undefined ? slide.dataset.mobSpacebetween : slide.dataset.spacebetween != undefined ? slide.dataset.spacebetween : 5,
      loop: loopSetting,

      scrollSetting: scrollSetting,
    
      // If we need pagination
      pagination: {
        el: '.swiper-button-pagination-'+i,
        clickable: true,
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next-'+i,
        prevEl: '.swiper-button-prev-'+i,
      },
      breakpoints: {
        992: {
          spaceBetween: slide.dataset.spacebetween != undefined ? slide.dataset.spacebetween : 5,
        }
      },
    
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar-'+i,
      },
    });

    // console.log('swiper',swiper)
  })


  if(window.location.href.includes('/collections') && !window.location.href.includes('venetian') && !window.location.href.includes('/new-arrivals') && !window.location.href.includes('/products') && !window.location.href.includes('filter.v.availability=1')){
    if(document.querySelector('label[for="FilterLarge-Availability-1"]') != null){
      document.querySelector('label[for="FilterLarge-Availability-1"]').click();
    }
  }

  // select instock filter only on collection pages and if no availibility filter is selected
  if(window.location.href.includes('/collections') && !window.location.href.includes('venetian') && !window.location.href.includes('/new-arrivals') && !window.location.href.includes('/products') && !window.location.href.includes('filter.v.availability=1')){
    if(document.querySelector('label[for="filter-Availability-1"]') != null){
      document.querySelector('label[for="filter-Availability-1"]').click();
    }
  }

  // add slider on mobile
  if(document.querySelector('body').classList.contains('bogo-offer-page')){
    var init = false;
    var bogoswiper;
    function swiperCard() {
      if (window.innerWidth <= 991) {
        if (!init) {
          init = true;
          bogoswiper = new Swiper(".product_imgs", {
            direction: "horizontal",
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 0,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else if (init) {
        bogoswiper.destroy();
        init = false;
      }
    }
    swiperCard();
    window.addEventListener("load", swiperCard);
    window.addEventListener("resize", swiperCard);
  }

  // show sticky atc when main atc is not visible 
  if(window.location.href.includes('/products')){
    // Select the elements
    const targetElement = document.querySelector('.product__submit__buttons');
    const toggleElement = document.querySelector('.zrx-sticky-atc-bar');

    // Create an Intersection Observer
    if(toggleElement != null){
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio === 1) {
              // Target is 100% visible
              toggleElement.classList.remove('zrx-sticky-atc-show');
            } else {
              // Target is not 100% visible
              toggleElement.classList.add('zrx-sticky-atc-show');
            }
          });
        },
        {
          threshold: 1.0, // Fire only when the element is 100% visible
        }
      );
  
      // Observe the target element
      observer.observe(targetElement);
    }
  }

  function loadAppData() {
    if (document.querySelectorAll('[data-app-section]').length) {
      document.querySelectorAll('[data-app-section]').forEach(function (doc) {
        // add insta username
        if (doc.querySelector('#insta-feed') != null) {
          console.log('hellyy');
          let instaId = doc.dataset.instaId;
          let instaLink = doc.dataset.instaLink;
          console.log('instaId',instaId,'instaLink',instaLink);
          let customTitle = setInterval(function () {
            if (doc.querySelector('#insta-feed h2') != null) {
              clearInterval(customTitle);
              setTimeout(()=>{
                console.log('heyyy');
                console.log(doc.querySelector('#insta-feed h2'));
                doc.querySelector('#insta-feed h2').insertAdjacentHTML('beforeend', `<a class="btn btn--solid btn--large btn--primary" target="_blank" href="${instaLink}" >${instaId}</a>`);
                console.log(doc.querySelector('#insta-feed h2 a'));
                
              },2500)
             
            }
          })
        }
      })
    }
  }

if (window.innerWidth < 767 ) {
  const target = document.querySelector('.product__price--off');
  console.log(target, 'target')
}
window.addEventListener('scroll', function () {
  if (window.innerWidth < 767 ) {
    
    const target = document.querySelector('.final_atc_step');
    const wrapper = document.querySelector('.final_atc_step-wrapper');
    if (!target || !wrapper) return;
  
    const wrapperRect = wrapper.getBoundingClientRect();
  
    const isVisibleFromBottom = wrapperRect.bottom <= window.innerHeight;
    const isFullyBelowViewport = wrapperRect.top >= window.innerHeight;
  
    if (isVisibleFromBottom && !target.classList.contains('fixed')) {
      target.classList.add('fixed');
    }
  
    if (isFullyBelowViewport && target.classList.contains('fixed')) {
      target.classList.remove('fixed');
    }
  }
});

if(window.location.href.includes('/pages/dali-canvas-espadrilles')){
document.querySelectorAll('[data-popup-open]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modal = document.querySelector('.product-modal');
      console.log(modal, 'modal')
      if (modal) {
        modal.setAttribute('open', '');      // Adds the 'open' attribute
        modal.removeAttribute('inert');     // Removes the 'insert' attribute
      }
    });
  });
  document.querySelectorAll('[data-popup-close]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modal = document.querySelector('.product-modal');
      console.log(modal, 'modal')
      if (modal) {
        modal.setAttribute('inert', '');      // Adds the 'open' attribute
        modal.removeAttribute('open');     // Removes the 'insert' attribute
      }
    });
  });
}
   
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



// custmization

// ============================
// 🔁 SYNC SIZE SELECT + RADIO
// ============================
function initStickySizeSync() {
  console.log('init sticky')
  const stickySelect = document.querySelector('.sticky-atc-select-wrapper select.sticky-size');
  const sizeRadios = document.querySelectorAll('.radio__fieldset [data-index="option2"]');
  if (!stickySelect || !sizeRadios.length) return;

  // 👉 From dropdown → radio
  stickySelect.addEventListener('change', (e) => {
    const selectedValue = e.target.value.trim().replaceAll('.', '-');
    sizeRadios.forEach(radio => (radio.checked = false));
    const matchedRadio = Array.from(sizeRadios).find(r => (r.value).replaceAll('.', '-') === selectedValue);
    
    // console.log('...change', selectedValue);
    // sizeRadios.forEach(radio => {
    //   console.log(radio.value,'..radio selected');
    //   if(selectedValue == radio.value.replaceAll('.', '-')){
    //     console.log(radio.value, '...selected');
    //     radio.checked = true;
    //   }
    // })
    if (matchedRadio) {
      matchedRadio.checked = true;
      matchedRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // 👉 From radio → dropdown
  sizeRadios.forEach(radio => {
    if(radio.checked){
      stickySelect.value = (radio.value).replaceAll('.', '-');
    }
    radio.addEventListener('change', (e) => {
      if (e.target.checked) {
        stickySelect.value = (e.target.value).replaceAll('.', '-');
      }
    });
  });

  setTimeout(() => {
    let allSize = document.querySelectorAll('.radio__button .sold-out');
    allSize.forEach(disableSize => {
      const sizeValue = (disableSize.value).replace('.', '-');     // get size value
      if (!sizeValue) return;                  
  
      const stickyOption = document.querySelector(
        `.sticky-size option[value="${sizeValue}"]`
      );
  
      if (stickyOption) {
        // stickyOption.disabled = true;          // disable option
        // stickyOption.classLi = true;          // disable option
      }
    });
  }, 1000);

  document.querySelectorAll('[data-popup-open]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modal = document.querySelector('.product-modal');
      console.log(modal, 'modal')
      if (modal) {
        modal.setAttribute('open', '');      // Adds the 'open' attribute
        modal.removeAttribute('inert');     // Removes the 'insert' attribute
      }
    });
  });
  document.querySelectorAll('[data-popup-close]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modal = document.querySelector('.product-modal');
      console.log(modal, 'modal')
      if (modal) {
        modal.setAttribute('inert', '');      // Adds the 'open' attribute
        modal.removeAttribute('open');     // Removes the 'insert' attribute
      }
    });
  });
}

// ============================
// 🛒 STICKY ADD-TO-CART BUTTON
// ============================
function initStickyAtcClick() {
  const stickyBtn = document.querySelector('.sticky-atc-main-button');
  if (!stickyBtn) return;

  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();

    // Skip if disabled
    if (stickyBtn.hasAttribute('disabled')) return;

    const mainForm = document.querySelector('product-form');
    if (!mainForm) return;

    const addBtn = mainForm.querySelector('[action="/cart/add"] [type="submit"]');
    if (addBtn) addBtn.click();
  });
}

// ============================
// 🔄 UPDATE STICKY ATC STATE
// ============================
function updateStickyAtcState() {
  const popupBtn = document.querySelector('[data-add-to-cart]');
  const stickyBtn = document.querySelector('.sticky-atc-main-button');
  if (!popupBtn || !stickyBtn) return;

  const popupText = popupBtn.textContent.trim();

  if(document.querySelector('.show-product-notification.variant--soldout button[data-add-to-cart][disabled]')){
    stickyBtn.textContent = "Sold Out";
    stickyBtn.setAttribute("disabled", "disabled");
    stickyBtn.classList.add("disabled");
  }else{
    stickyBtn.textContent = "Add to Cart";
    stickyBtn.removeAttribute("disabled");
    stickyBtn.classList.remove("disabled");
  }
}

// Optional: observe popup button text changes (e.g. variant switch)
function observePopupChanges() {
  const popupBtn = document.querySelector('[data-add-to-cart]');
  if (!popupBtn) return;

  const observer = new MutationObserver(() => updateStickyAtcState());
  observer.observe(popupBtn, { childList: true, subtree: true, characterData: true });
}

// ============================
// 🔁 RE-RENDER PRODUCT SECTIONS
// ============================
function reRender(url) {
  const sections = [
    'product-info',
    '.product__block--buttons',
    '.sticky-cart',
    '#product-features'
  ];

  // Add loading class
  sections.forEach(sel => {
    const el = document.querySelector(sel);
    console.log(el,'...')
    if (el) el.classList.add('loading');
  });

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Replace sections
      sections.forEach(sel => {
        const currentEl = document.querySelector(sel);
        const newEl = doc.querySelector(sel);
        if (currentEl && newEl) currentEl.replaceWith(newEl);
      });
    })
    .catch(err => console.error('⚠️ Error re-rendering product sections:', err))
    .finally(() => {
      sections.forEach(sel => {
        const el = document.querySelector(sel);
        if (el) el.classList.remove('loading');
      });

      // ✅ Re-init after re-render
      initStickySizeSync();
      initStickyAtcClick();
      updateStickyAtcState();
      observePopupChanges();
      checkScroll();
      if (typeof window.klInitTracking === 'function') window.klInitTracking();


      // if(window.location.href.includes('venetian-loafers')){
      //   if (window.BIS) {
      //     BIS.setProduct();
      //     BIS.watch();   // optional but useful
      //   }
      // }
     

    });

  // Highlight current swatch
  document.querySelectorAll('.product__content radio-swatch')
    .forEach(mainswatch => mainswatch.classList.remove('current_sibling_container'));

  const mainDiv = event.target.closest('.swatches.swatch__button');
  if (mainDiv) {
    mainDiv.classList.add('current_sibling_container');
    const targetLink = mainDiv.querySelector('a');
    if (targetLink) targetLink.classList.add('sibling__link--current');
  }
  window.history.pushState({}, '', url);


  setTimeout(() => {
    const el = [...document.querySelectorAll('.product__block strong')]
      .find(s => s.textContent.trim().toLowerCase() === 'final sale')
      ?.closest('.product__block');
    if(document.querySelector('.final-sale-product') != null && el != null){
      el.style.display = 'flex';
    } else{
      el.style.display = 'none';
    }
  },500)
}

function checkScroll(){
  const stickyCart = document.querySelector('.sticky-cart');
  const productForm = document.querySelector('.product-form');
  if (!stickyCart) return;

  window.addEventListener('scroll', () => {
    if (!productForm || !stickyCart) return;

    const formRect = productForm.getBoundingClientRect();

    // If the bottom of .product-form is above the top of the viewport → it's gone up
    if (formRect.bottom < 0) {
      stickyCart.classList.add('visible');
    } else {
      stickyCart.classList.remove('visible');
    }
  });
}
// ============================
// 🚀 INIT ON PAGE LOAD
// ============================
// ============================
// 📏 SIZE CHART ACCORDION LINK
// Delegated — works after rerender without rebinding
// ============================
document.addEventListener('click', function(e) {
  var link = e.target.closest('[data-size-fit-link]');
  var FinalSalelink = e.target.closest('[data-final-sale-link]');
  if (!link && !FinalSalelink) return;

  e.preventDefault();

  if(link){
      // Close the size chart modal via its close button
      var modal = link.closest('dialog.product-modal');
      if (modal) {
        var modalClose = modal.querySelector('.product-modal__close');
        if (modalClose) modalClose.click();
      }

      // Find and expand the Size + Fit accordion
      setTimeout(function() {
        document.querySelectorAll('[data-collapsible-trigger]').forEach(function(trigger) {
          if (trigger.textContent.trim().startsWith('Size + Fit')) {
            trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (trigger.getAttribute('aria-expanded') !== 'true') {
              trigger.click();
            }
          }
        });
      }, 150);
  }
  if(FinalSalelink){
    setTimeout(function() {
        document.querySelectorAll('[data-collapsible-trigger]').forEach(function(trigger) {
          if (trigger.textContent.trim().startsWith('Final Sale')) {
            trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (trigger.getAttribute('aria-expanded') !== 'true') {
              trigger.click();
            }
          }
        });
      }, 150);
  }

});

document.addEventListener('DOMContentLoaded', () => {
  initStickySizeSync();
  initStickyAtcClick();
  updateStickyAtcState();
  observePopupChanges();
  checkScroll();
});


// new arrivals

function activateTab(tabValue) {
  if (!tabValue) return;
  if(tabValue.includes('women') > 0 || tabValue == 1){
    tabValue = 1
  }else{
    tabValue = 2
  }
  const targetGroups = document.querySelectorAll(
    '.collection-tabs.hide-tablet-and-up, .collection-tabs.hide-mobile'
  );

targetGroups.forEach(group => {

  const tabs = group.querySelectorAll('.tab-link');

  // Remove current from all tabs in this group
  setTimeout(() => {
    tabs.forEach(tab => {
      tab.classList.remove('current');
    });
  
    // Find matching tab
    const match = group.querySelector(
      `.tab-link[data-tab="${tabValue}"]`
    );
    
    if (match) {
      match.classList.add('current');
    }
  }, 200);
});

}


// CLICK HANDLER
document.querySelectorAll('.collection-tabs').forEach(group => {
  group.addEventListener('click', function (e) {
    const tab = e.target.closest('.tab-link');
    if (!tab) return;

    e.preventDefault(); // 🚀 stop default anchor scroll

    const tabValue = tab.dataset.tab;

    activateTab(tabValue);

    // Update URL without triggering jump
    history.replaceState(null, null, `#${tabValue}`);

    // Manual smooth scroll with offset
    scrollToSection(tabValue);
  });
});

function scrollToSection(tabValue) {
  const section = document.querySelector(`[data-rel-coll][data-tab-section="${tabValue}"]`);
  if (!section) return;

  const stickyNav = document.querySelector('.collection__nav');
  const offset = stickyNav ? stickyNav.offsetHeight : 0;

  const stickyHeader = document.querySelector('.theme__header');
  const stickyHeaderOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
  

  const top =
    section.getBoundingClientRect().top +
    window.pageYOffset -
    offset -
    stickyHeaderOffset + 2;

  window.scrollTo({
    top: top,
    behavior: 'smooth'
  });
}


// URL HASH CHECK ON PAGE LOAD
document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash.replace('#', '');
  if (!hash) return;

  const match = document.querySelector(`.tab-link[data-tab="${hash}"]`);
  
  if (match) {
    activateTab(hash);
  }
});

function initScrollTabs() {
  const sections = document.querySelectorAll('[data-rel-coll]');
  const headerOffset = 146; // adjust to sticky header height

  function updateActiveTab() {
    let current = null;

    sections.forEach(section => {
      const rect = section.getBoundingClientRect();

      if (rect.top <= headerOffset && rect.bottom > headerOffset) {
        current = section.dataset.tabSection;
      }
    });

    if (current) 
    activateTab(current);
  }

  window.addEventListener('scroll', updateActiveTab);
  updateActiveTab();
}

document.addEventListener('DOMContentLoaded', initScrollTabs);


const hash = window.location.hash.replace('#', '');
activateTab(hash);


//  same height to 
function equalProductLinkHeight() {

    const items = document.querySelectorAll('grid-item .product-item__info');

    // Reset height first
    items.forEach(item => {
      item.style.height = 'auto';
    });

    let maxHeight = 0;

    // Find tallest
    items.forEach(item => {
      if (item.offsetHeight > maxHeight) {
        maxHeight = item.offsetHeight;
      }
    });

    // Apply tallest height
    items.forEach(item => {
      item.style.height = maxHeight + 'px';
    });
}

// Run on load
window.addEventListener('load', equalProductLinkHeight);

// Run on resize (with debounce for performance)
let resizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(equalProductLinkHeight, 200);
});

const tabs = document.querySelectorAll('[data-scrollbar] .tab-link');

tabs.forEach(tab => {
  tab.addEventListener('click', function () {
    
    setTimeout(function () {
      equalProductLinkHeight();
    }, 200);

  });
});
  function equalHeights() {
    const items = [...document.querySelectorAll('.swatches-title-container')];
    if (!items.length) return;

    // Reset heights
    items.forEach(item => {
        item.style.height = 'auto';
    });

    // Desktop → all items same height
    
    if (window.innerWidth >= 768) {
      
        let maxHeight = 0;

        items.forEach(item => {
            maxHeight = Math.max(maxHeight, item.offsetHeight);
        });

        console.debug(maxHeight, "window.innerWidth")
        items.forEach(item => {
            item.style.height = maxHeight + 'px';
        });

    } else {
        // Mobile → 2 items per row
        for (let i = 0; i < items.length; i += 2) {
            const group = items.slice(i, i + 2);

            let maxHeight = 0;

            group.forEach(item => {
                maxHeight = Math.max(maxHeight, item.offsetHeight);
            });

            group.forEach(item => {
                item.style.height = maxHeight + 'px';
            });
        }
    }
}

  // Observe visibility
  const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              equalHeights();
          }
      });
  }, { threshold: 0.1 });

  // Attach observer
  document.querySelectorAll('.swatches-title-container').forEach(el => {
      observer.observe(el);
  });

  // Also run initially
  window.addEventListener("load", equalHeights);
  window.addEventListener("resize", equalHeights);
  document.addEventListener("DOMContentLoaded", () => {
      requestAnimationFrame(() => {
          requestAnimationFrame(equalHeights);
      });
  });  